export default "__VITE_ASSET__bsG30Rz7__"